export enum eReducerStatusBase {
    is_not_initialization = "is_not_initialization",

    is_loading = "is_loading",
    is_loaded = "is_loaded",
    is_load_err = "is_load_err",

    is_saving = "is_saving",
    is_saved = "is_saved",
    is_save_err = "is_save_err",

    is_deleting = "is_deleting",
    is_deleted = "is_deleted",
    is_delete_err = "is_delete_err",

    is_need_reload = "is_need_reload"
}
